import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantsService {

  private readonly tenantsURL: string;


  constructor(private http: HttpClient) {
    this.tenantsURL = '/api/tenants';
  }

  public getTenantSummaries(): Observable<any> {
    const url: string = `${this.tenantsURL}/summary`;
    return this.http.get<any>(url);
  }

}
